import styled from 'styled-components';

/**
 * @atlaskit/tooltip adds a div container that has wrong dimensions
 * that cannot be chagned via any props.
 */
export const ContainerStyled = styled.div`
  > div {
    width: 16px;
    height: 16px;
  }
`;
